<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">Información del retiro</h4>
  <button type="button" class="btn close btn-default shadow-none" aria-label="Close" (click)="activeModal.dismiss(false)">
    <span class="material-icons-outlined">
      close
      </span>
  </button>
</div>
<div class="modal-body">
  <div class="row p-1">

    <div class="col-12 col-md-6">
      <div class="mx-auto">
        <label>ID de retiro</label>
        <input placeholder="" type="text" [(ngModel)]="withdraw.withdrawPropertyID" name="parameter-payrollID" class="form-control">
      </div>
    </div>

    <div class="col-12 col-md-6">
      <div class="mx-auto">
        <label>Titulo del retiro</label>
        <input placeholder="" type="text" [(ngModel)]="withdraw.title" name="parameter-title" class="form-control">
      </div>
    </div>

  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-danger me-2" (click)="this.activeModal.dismiss(false)">Cancelar</button>
  <button type="button" class="btn btn-primary me-2" (click)="createdParameter()">Crear Retiro</button>
</div>
